import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectPlacingMoneySource } from '../../../../selectors/publishTerms';
import { setPlacingMoneySource } from '../../../../redux/reducers';

import { MoneySource } from './MoneySource';

export const MoneySourceContainer = () => {
  const dispatch = useDispatch();
  const moneySource = useSelector(selectPlacingMoneySource);

  const handleChange = React.useCallback(
    value => {
      dispatch(setPlacingMoneySource(value));
    },
    [dispatch],
  );

  return <MoneySource value={moneySource || ''} handleChange={handleChange} />;
};
